import React from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { getAllPokemons, getPokemonByName } from "../../store/actions/index";
import "./Search.css";

const SearchBar = () => {
	const dispatch = useDispatch();
	const [inputName, setInputName] = useState("");

	const handleChange = (e) => {
		setInputName(e.target.value);
	};

	console.log(inputName);
	const handleSubmit = (e) => {
		if (!inputName.length) {
			dispatch(getAllPokemons());
			return alert("Please insert a name");
		} else {
			e.preventDefault();
			dispatch(getPokemonByName(inputName));
			setInputName("");
		}
	};

	const handleKeyDown = (e) => {
		if (e.key === "Enter") {
			handleSubmit(e);
		}
	};

	return (
		<div>
			<input
				className="input-search"
				type="text"
				placeholder="Search pokemon..."
				onChange={(e) => handleChange(e)}
				value={inputName}
				onKeyDown={(e) => handleKeyDown(e)}
			/>
			<button
				type="submit"
				onClick={(e) => handleSubmit(e)}
				className="btn-search"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="1em"
					height="1em"
					preserveAspectRatio="xMidYMid meet"
					viewBox="0 0 24 24"
				>
					<path
						fill="currentColor"
						d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5A6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5S14 7.01 14 9.5S11.99 14 9.5 14z"
					/>
				</svg>
			</button>
		</div>
	);
};

export default SearchBar;
